import Swiper, {Navigation, Lazy} from "swiper";
Swiper.use([Navigation, Lazy]);

const initFeedbackSlider = () => {
  const slider = document.querySelector("[data-feedback] .cases-slider");

  slider &&
    new Swiper(slider, {
      loop: true,
      lazy: true,
      watchSlidesProgress: true,

      breakpoints: {
        660: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        0: {
          slidesPerView: 1.05,
          spaceBetween: 10,
        },
      },

      navigation: {
        nextEl: "[data-feedback] .slider-navigation__button--next",
        prevEl: "[data-feedback] .slider-navigation__button--prev",
      },
    });
};

export default initFeedbackSlider;
